/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleClaimStatusFieldRows: '$MHF_ModelNameVal_$MHF|TeleClaimStatusFieldRows',

};
